module.exports = __webpack_public_path__ + "static/media/ad.3efe9dc2.svg";